import { Theme } from "@material-ui/core";
import { createStyles } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

export const FooterStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: {
      flexShrink: 0,
      marginBottom: 70,
      padding: 10,
      display: "flex",
      alignItems: "center",
    },
    user: {
      marginLeft: "auto",
    },
  })
);
